// extracted by mini-css-extract-plugin
export var arrow = "banner-module--arrow--c7L8n";
export var banner = "banner-module--banner--EjDoz";
export var fadeUp = "banner-module--fadeUp--CU2+x";
export var line = "banner-module--line--fSIMq";
export var logo = "banner-module--logo--1pbjm";
export var subtitle = "banner-module--subtitle--2mtwl";
export var text = "banner-module--text--SeTjw";
export var title = "banner-module--title--AfgLu";